import { t } from 'i18next'

import { FormGroup, Input, Label } from '~/components/unform'

export const IdentificationFields = ({
  onChange
}: {
  onChange: (value: AdSizeOption) => void
}) => (
  <>
    <FormGroup className="w-100">
      <Label
        text={t('rm:adsize.form.text.identifier')}
        helperText={t('rm:adsize.form.helpText.identifier')}
        htmlFor="name"
        isRequired
      />
      <Input name="name" onChange={onChange} required />
    </FormGroup>

    <FormGroup className="w-100">
      <Label
        text={t('rm:adsize.form.text.label')}
        helperText={t('rm:adsize.form.helpText.label')}
        htmlFor="label"
      />
      <Input name="label" />
    </FormGroup>
  </>
)
